import React from "react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getTokenInfo } from "../../../utils/Guard";
import { useNavigate } from "react-router-dom";
import { GetCharges } from "../../../store/charge-store/charge-actions";
import { chargeActions } from "../../../store/charge-store/charge-slice";
import { Button } from "primereact/button";
import ABADatatable from "../../../components/ABADataTable/ABADatatable";

const ChargesHomePage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const userInfo = getTokenInfo();
  const charge = useSelector((state) => state.charge);

  useEffect(() => {
    if (
      userInfo.Roles !== undefined &&
      userInfo.Roles.includes("charge.showAll")
    ) {
      dispatch(GetCharges(userInfo.Email, true));
    } else if (
      userInfo.Roles !== undefined &&
      !userInfo.Roles.includes("charge.menu")
    ) {
      window.location.href = "/home";
    }
  }, [dispatch, userInfo.Email, userInfo.Roles]);

  const viewDetailHanlder = (val) => {
    navigate(`/charges/detail/${val.id}`);
  };
  const editHanlder = (val) => {
    navigate(`/charges/edit/${val.id}`);
  };
  const createHanlder = () => {
    dispatch(
      chargeActions.setCharge({
        charge: {
          id: 0,
          name: "",
          description: "",
          status: false,
        },
      })
    );
    navigate(`/charges/create`);
  };

  const backHanlder = () => {
    navigate(`/`);
  };
  let actions = [];
  const buttons = (rowData) => {
    let buttons = [];
    const buttonEdit = (
      <Button
        label="Editar"
        icon="pi pi-file-edit"
        className="p-button-rounded p-button-success p-button-text"
        onClick={() => {
          editHanlder(rowData);
        }}
      />
    );
    const buttonView = (
      <Button
        label="Ver"
        icon="pi pi-info-circle"
        className="p-button-rounded p-button-text"
        onClick={() => {
          viewDetailHanlder(rowData);
        }}
      />
    );
    if (
      userInfo.Roles !== undefined &&
      userInfo.Roles.includes("charge.edit")
    ) {
      buttons.push(buttonEdit);
    }
    if (
      userInfo.Roles !== undefined &&
      userInfo.Roles.includes("charge.view")
    ) {
      buttons.push(buttonView);
    }
    return buttons;
  };
  actions.push(buttons);

  const columns = [
    {
      field: "name",
      header: "Nombre",
      filterMatchMode: "contains",
    },

    {
      field: "description",
      header: "Descripción",
      filterMatchMode: "contains",
    },
    {
      field: "status",
      header: "Estado",
      filterMatchMode: "contains",
    },
  ];

  return (
    <>
      <div
        style={{ backgroundColor: "#133047", padding: "1%", height: "118vh" }}
      >
        <ABADatatable
          width="40%"
          height="100vh"
          title="Cargos"
          values={charge.charges}
          rows={5}
          rowsPerPageOptions={[5, 10, 20]}
          Columns={columns}
          actions={actions}
          createButton={{
            label: "Agregar",
            onClick: createHanlder,
            permission: "charge.create",
          }}
          backButton={{
            label: "Regresar",
            onClick: backHanlder,
            permission: "goBack",
          }}
        />
      </div>
    </>
  );
};
export default ChargesHomePage;
